import React from "react";

import "./freebie-event-modal-style.scss";

import BasicModal from "@src/componentsNew/Modals/BasicModal/BasicModal";
import Typography from "@src/componentsNew/Typography/Typography";
import GiftIcon from "@src/componentsNew/Icons/Icons/GiftIcon";

import { product_product } from "@components/ProductPage/ProductDetailPage/__generated__/product";

interface IProps {
  product: product_product;
  open: boolean;
  onClose: () => void;
}

const FreebieEventModal = ({ product, open, onClose }: IProps) => {
  return (
    <BasicModal
      modalId="mobile-detail-freebie-modal"
      title="Freebie"
      titleColor="#000000DE"
      content={
        <>
          {
            product.freebieEvents.map((freebieEvent, idx) =>
              <div key={freebieEvent.id} className={`freebie-modal-content ${idx === 0 ? 'first' : ''} ${idx === product.freebieEvents.length - 1 ? 'last' : ''}`}>
                <GiftIcon cName="gift-icon" width="18" height="18" />

                <Typography cName="freebie-modal-text" variant="body3" component="span" style={{ color: "#666666" }}>
                  {freebieEvent.name}
                </Typography>
              </div>
            )
          }
        </>
      }
      contentColor="#666666"
      open={open}
      onClose={onClose}
      closeButtonText="Close"
      showCloseIcon={false}
    />
  )
}

export default FreebieEventModal;
